var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconViverse = function SvgIconViverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.712 1.567a11 11 0 0 1 3.338 5.84c.265 1.257-.52 2.558-1.748 2.943-1.05.33-2.143.45-3.302.45-1.158 0-2.25-.12-3.3-.45C1.473 9.965.689 8.664.954 7.406a11 11 0 0 1 3.336-5.839 2.53 2.53 0 0 1 3.423 0M8.098 8.7c-.641.2-1.39.3-2.099.3s-1.456-.1-2.096-.3c-.75-.233-1.15-.995-.987-1.756a6.66 6.66 0 0 1 2.038-3.539c.591-.54 1.499-.54 2.09 0a6.65 6.65 0 0 1 2.04 3.54c.162.76-.235 1.522-.986 1.755",
    clipRule: "evenodd"
  })));
};
export default SvgIconViverse;